import { useMemo } from 'react'

import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { isObject } from '../../../../utils'
import { EUROPEAN_DATE, getTimezoneLessMoment } from '../../../../utils/momentjs'

const DateCell = ({ className, internship, placement, startDate, endDate }) => {
  const t = useSelector(selectTranslate)

  const title = useMemo(() => (
    <div className='flex-column'>
      <u><b> {t('common.period')} </b></u>
      <span> {getTimezoneLessMoment(startDate).format(EUROPEAN_DATE)} - {getTimezoneLessMoment(endDate).format(EUROPEAN_DATE)} </span>
      <u><b> {t('common.school')} </b></u>
      <span> {isObject(internship.school) ? internship.school.name : t('Without school')} </span>
      <u><b> {t('common.institution')} </b></u>
      <span> {isObject(internship.institution) ? internship.institution.name : t('Without institution')} </span>
      <u><b> {t('common.speciality')} </b></u>
      <span> {isObject(internship.speciality) ? internship.speciality.name : t('Without speciality')} </span>
      <u><b> {t('common.assistant')} </b></u>
      <span> {isObject(internship.assistant) ? `${internship.assistant.firstname} ${internship.assistant.lastname}` : t('Without assistant')} </span>
    </div>
  ), [])

  return (
    <Tooltip placement={placement} title={title}>
      <div className={`has-internship ${className ? ` ${className}` : ''}`} style={{ width: '100%', height: '100%' }} />
    </Tooltip>
  )
}

export default DateCell
